(() => {
  document.querySelectorAll('[data-erbe-logo-navigation]').forEach(root => {
    if (root.dataset.bound) return;
    root.dataset.bound = 'true';
    const button = root.querySelector('button');
    const panel = root.querySelector('nav');
    const desktop = matchMedia('(min-width:1100px)');
    let timer;
    const setOpen = open => {
      clearTimeout(timer);
      panel.hidden = !open;
      button.setAttribute('aria-expanded', String(open));
    };
    root.addEventListener('pointerenter', event => {
      if (desktop.matches && event.pointerType === 'mouse') setOpen(true);
    });
    root.addEventListener('pointerleave', () => {
      timer = setTimeout(() => {
        if (!root.contains(document.activeElement)) setOpen(false);
      }, 180);
    });
    button.addEventListener('click', event => setOpen(event.detail > 0 && root.matches(':hover') ? true : panel.hidden));
    root.addEventListener('focusout', () => {
      setTimeout(() => { if (!root.contains(document.activeElement)) setOpen(false); }, 0);
    });
    root.addEventListener('keydown', event => {
      if (event.key === 'Escape') { setOpen(false); button.focus(); }
      if (event.target === button && event.key === 'ArrowDown') {
        event.preventDefault(); setOpen(true); panel.querySelector('a')?.focus();
      }
    });
    document.addEventListener('click', event => { if (!root.contains(event.target)) setOpen(false); });
    desktop.addEventListener('change', () => setOpen(false));
  });
})();

(() => {
  const preference = matchMedia('(prefers-reduced-motion: reduce)');
  let observer;
  const revealWorks = () => {
    if (!document.querySelector('.hero[id$="__hero_RkimKJ"]') || preference.matches || !('IntersectionObserver' in window)) return;
    observer ||= new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('erbe-work-visible');
        observer.unobserve(entry.target);
      });
    }, {threshold: .08});
    document.querySelectorAll('main product-card:not(.erbe-work-enter)').forEach(card => {
      if (card.getBoundingClientRect().top < innerHeight) return;
      card.classList.add('erbe-work-enter');
      observer.observe(card);
    });
  };
  revealWorks();
  document.addEventListener('shopify:section:load', revealWorks);
  preference.addEventListener('change', () => {
    if (preference.matches) {
      observer?.disconnect();
      document.querySelectorAll('.erbe-work-enter').forEach(card => card.classList.add('erbe-work-visible'));
    }
  });
})();
